// Follows "HR Design rules.md": GEN, DIS
import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

/** On/off switch (design system `switch`): `input` track off, primary on, grey tokens when disabled. */
function Switch({
  className,
  size = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & { size?: 'sm' | 'default' }) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "group/switch peer relative inline-flex shrink-0 items-center rounded-full border border-transparent shadow-sm transition-[background-color,box-shadow] duration-fast ease-standard outline-none after:absolute after:-inset-[5px] after:content-['']",
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        // Prototype `.switch`: 36×20 track, 16px knob.
        'data-[size=default]:h-5 data-[size=default]:w-9 data-[size=sm]:h-3.5 data-[size=sm]:w-6',
        'data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
        'disabled:cursor-not-allowed disabled:shadow-none disabled:!border-disabled-border disabled:!bg-disabled',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block rounded-full bg-card ring-0 transition-transform duration-fast ease-standard',
          'group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3',
          // Default size: 2px in from the track edge (the track has a 1px border), 16px of travel.
          'group-data-[size=default]/switch:data-[state=checked]:translate-x-[17px] group-data-[size=default]/switch:data-[state=unchecked]:translate-x-px',
          'group-data-[size=sm]/switch:data-[state=checked]:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-[state=unchecked]:translate-x-0',
          'dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground',
          'group-disabled/switch:!bg-disabled-foreground'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
